import React from 'react';

import DataGrid from '@gogame/data-grid';
import {
  useScreenTitle,
  useScreenDispatch,
  useScreenState,
} from '@gogame/screens';

import { useLoadPostbacksReportTable } from 'scenes/PostbacksReport/data';
import {
  REORDER_COLUMNS,
  COLLAPSE_COLUMNS,
  SET_TABLE_SETTINGS,
} from 'scenes/PostbacksReport/screenReducer';
import {
  COLUMN_POSTBACK_DATE,
  COLUMN_APPLICATION_NAME,
  COLUMN_AFFILIATE_NAME,
  COLUMN_CAMPAIGN_ID,
  COLUMN_CAMPAIGN_NAME,
  COLUMN_REG_ACTION_ID,
  COLUMN_REGISTRATION_DATE,
  COLUMN_EVENT_TIME,
  COLUMN_EVENT_NAME,
  COLUMN_POSTBACK_URL,
  COLUMN_AD_CLICK_ID,
} from '../constants';
import Toolbar from './Toolbar';

const PostbacksReportDataTable = () => {
  const [screenTitle] = useScreenTitle();
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const { data, isLoading, isRefetching } = useLoadPostbacksReportTable(
    {
      filters: screenState.filters,
      tableSettings: screenState.tableSettings,
    },
    {
      enabled: screenState.ready,
    }
  );

  const handleChangeSettings = (settings) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: settings,
    });
  };

  const handleCollapse = (collapsed) => {
    dispatch({
      type: COLLAPSE_COLUMNS,
      payload: collapsed,
    });
  };

  const handleReorder = (order) => {
    dispatch({
      type: REORDER_COLUMNS,
      payload: order,
    });
  };

  return (
    <DataGrid
      rows={data?.rows}
      count={data?.count}
      title={screenTitle}
      loading={isLoading}
      fetching={isRefetching}
      ready={screenState.ready}
      onChangeSettings={handleChangeSettings}
      onReorder={handleReorder}
      onCollapse={handleCollapse}
      tableSettings={screenState.tableSettings}
      columnsState={screenState.columns}
      toolbar={<Toolbar />}
      storageKey={'postbacks-report'}
      defaultColumnWidth={160}
    >
      <DataGrid.Column
        field={COLUMN_POSTBACK_DATE}
        type={'date'}
        headerName={'Postback sent time'}
        width={150}
        fixed={true}
        resizable={false}
        template={'LLL'}
      />
      <DataGrid.Column
        field={COLUMN_APPLICATION_NAME}
        headerName={'Application'}
        width={120}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_AFFILIATE_NAME}
        headerName={'Affiliate'}
        width={190}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_CAMPAIGN_ID}
        headerName={'Campaign ID'}
        width={100}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_CAMPAIGN_NAME}
        headerName={'Campaign name'}
        width={260}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_REG_ACTION_ID}
        headerName={'Reg Action ID'}
        width={140}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_REGISTRATION_DATE}
        headerName={'Registration Date'}
        width={150}
        type={'date'}
        template={'LLL'}
      />
      <DataGrid.Column
        field={COLUMN_AD_CLICK_ID}
        headerName={'Partner Click ID'}
        width={140}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_EVENT_TIME}
        headerName={'Event completion time'}
        width={150}
        type={'date'}
        template={'LLL'}
      />
      <DataGrid.Column
        field={COLUMN_EVENT_NAME}
        headerName={'Event name'}
        width={240}
        type={'text'}
      />
      <DataGrid.Column
        field={COLUMN_POSTBACK_URL}
        type={'text'}
        headerName={'Postback URL'}
        width={260}
      />
    </DataGrid>
  );
};

export default PostbacksReportDataTable;
